// Generated by purs version 0.15.15
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
var attrStringProp = {
    attr: Specular_Dom_Element.attr
};
var attrStringAttrs = {
    attr: Foreign_Object.singleton
};
var attrDynamicStringProp = {
    attr: Specular_Dom_Element.attrD
};
var attr = function (dict) {
    return dict.attr;
};
export {
    attr,
    attrStringAttrs,
    attrStringProp,
    attrDynamicStringProp
};
